// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2FMu5","fileBtn":"File_fileBtn__2tg9D","closeBtn":"File_closeBtn__19Ei0","fileSelected":"File_fileSelected__1ijEB","disabled":"File_disabled__2033h"};